// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d12c5173","457":"81546fb6","777":"26d8e174"}[chunkId] + ".chunk.js";
};